import React from 'react';
import { Row } from 'react-bootstrap';
import MultipleSelect from '../../components/MultipleSelect';
import LoadingSpinner from '../../components/LoadingSpinner';

export default class InsightSetInsights extends React.Component {
  static displayName = 'InsightSetInsights';

  constructor(props) {
    super(props);
    this.state = {
      loading: true
    };
    this.getInsights = this.getInsights.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    const insightSetId = this.props.params.insightSetId;
    this.getInsights(insightSetId);
  }

  getInsights(insightSetId) {
    Promise.all([
      this.props.getInsightSetInsights(insightSetId, true),
      this.props.getInsightSetInsights(insightSetId, false)
    ]).then(() => this.setState({ loading: false }));
  }

  handleSubmit(selectedItems, availableItems) {
    const selectedIdObjects = selectedItems.map(item => ({ id: item.id }));
    const insightSetId = this.props.params.insightSetId;
    this.props.updateInsightSetInsights(insightSetId, selectedIdObjects);
  }

  filterInsightTypes = insights => {
    const insightSetTypeId = this.props.currentInsightSet.insightSetTypeId;
    // Builder insight sets use type 1 insights
    const desiredTypeId = insightSetTypeId === 2 ? 1 : insightSetTypeId;

    return insights.filter(
      insight => insight.insightSetTypeId === desiredTypeId
    );
  };

  render() {
    const { allocated, unallocated } = this.props.currentInsightSet.insights;

    const filteredUnallocated = this.filterInsightTypes(unallocated);
    const filteredAllocated = this.filterInsightTypes(allocated);

    if (this.state.loading) {
      return <LoadingSpinner />;
    }

    return (
      <div>
        <Row />
        <MultipleSelect
          available={filteredUnallocated}
          selected={filteredAllocated}
          onSubmit={this.handleSubmit}
          currentInsightSet={this.props.currentInsightSet}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/insightset/InsightSetInsights.js